import React from 'react';
import { Upload } from 'antd';
import StorageUtils from '../../../utils/storage-session-utils';
import notifyUtitls from '../../../utils/notify-utils';

const UploadImage = ({ children, limitHeight, limitWidth, limitSize, ...props }) => {
    const { fileList = [] } = props;
    const uploadTempEndpoint = process.env.REACT_APP_API_ENDPOINT + "/upload/temp";
    const headers = {
        Authorization: 'Bearer ' + StorageUtils.getToken()
    }
    const beforeUpload = (file) => {
       
        const duplicate = fileList.find(({ name }) => name === file.name);
        if (duplicate) {
            notifyUtitls.warning('แจ้งเตือน', 'ไฟล์อัพโหลดมีชื่อซ้ำ!');
            return Upload.LIST_IGNORE;
        }

        if (!file.type.includes('image/')) {
            notifyUtitls.error({ title: 'แจ้งเตือน', message: 'ประเภทไฟล์รูปภาพไม่ถูกต้อง' });
            return Upload.LIST_IGNORE;
        }

        if (limitSize && file.size > limitSize) {
            notifyUtitls.error({ title: 'แจ้งเตือน', message: 'ไฟล์รูปภาพต้องมีขนาดไม่เกิน ' + limitSize + " bytes." });
            return Upload.LIST_IGNORE;
        }

        if (!limitHeight && !limitWidth) {
            return true;
        }

        //read file
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = document.createElement('img');
                img.src = reader.result;
                img.onload = () => {
                    const msgs = [];
                    if (limitWidth && this.width > limitWidth) {
                        msgs.push("ความกว้างของรูปภาพต้องไม่เกิน " + limitWidth + " px.");
                    }
                    if (limitHeight && this.height > limitHeight) {
                        msgs.push("ความสูงของรูปภาพต้องไม่เกิน " + limitHeight + " px.");
                    }
                    if (msgs.length > 0) {
                        notifyUtitls.error({ title: 'แจ้งเตือน', message: msgs.join(" และ") });
                        reject(Upload.LIST_IGNORE);
                    } else {
                        resolve(true);
                    }
                }
            }

        });
    }

    return (
        <Upload
            {...props}
            action={uploadTempEndpoint}
            method="POST"
            headers={headers}
            beforeUpload={beforeUpload}
        >
            {children}
        </Upload>
    )

}

export default UploadImage;